var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLayout5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 113,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip35"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 561,
    y: 250,
    width: 125,
    height: 113
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip35)",
    transform: "translate(-561 -250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.6277 208.792 209.343 208.792 209.343 320.393 85.6277 320.393Z",
    stroke: "current",
    strokeWidth: 1.26193,
    strokeMiterlimit: 8,
    fill: "#FFFFFF",
    transform: "matrix(1 0 0 1.00101 476.015 41.639)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayout5);
export default __webpack_public_path__ + "static/media/layout5.c6837fd9d52dddc3f4a4bcaf7cd17f41.svg";
export { ForwardRef as ReactComponent };